<template>
  <section>
    <link
      rel="stylesheet"
      href="//cdnjs.cloudflare.com/ajax/libs/leaflet/1.4.0/leaflet.css"
      type="text/css"
    />
    <section class="map-container">
      <div id="sunmap" v-on:keyup="handleKeyPress"></div>
    </section>
  </section>
</template>

<script>
import axios from 'axios';
import store from '../store';
import config from '../../common/config.js';
import { http } from '../services/http';
import * as L from 'leaflet';
import '../assets/leaflet-webatlas-0.1.0.min.js';
//import 'leaflet-webatlastile';
L.Icon.Default.imagePath =
  '//cdnjs.cloudflare.com/ajax/libs/leaflet/1.4.0/images/';

export default {
  name: 'SunMap',
  props: {},
  data() {
    return {
      map: null,
      layers: [],
      values: [0, 0, 0, 0, 0, 0, 0, 0],
    };
  },
  computed: {
    coordinates() {
      return store.state.coordinates;
    },
    roof: {
      get() {
        return store.state.roof;
      },
      set(roof) {
        store.commit('roofSelected', {
          roof: roof,
        });
      },
    },
    isLoading: {
      get() {
        return store.state.isLoadingBestRoof;
      },
      set(value) {
        store.commit('setIsLoadingBestRoof', value);
      },
    },
    currentPageIndex() {
      return store.state.currentPageIndex;
    },
  },
  watch: {
    coordinates(coordinates) {
      // We only want to lookup the best roof when we go to a location from search results
      if (coordinates.address) {
        this.findBestRoof(coordinates);
      }
    },
    currentPageIndex(index) {
      if (index === 0 && this.coordinates) {
        this.map.invalidateSize();
        this.navigateToRoof(this.coordinates.lat, this.coordinates.lng);
      }
    },
  },
  methods: {
    drawRoof(roof) {
      // eslint-disable-next-line
      const latlngs = this.geometriToLatLng(roof[0].Geometri);
      this.layers.forEach(p => this.map.removeLayer(p));
      const polygon = L.polygon(latlngs, {
        color: '#67BEA2',
        fillColor: '#67BEA2',
        fillOpacity: 1,
      }).addTo(this.map);
      this.map.fitBounds(polygon.getBounds());
      this.layers.push(polygon);
      const topCoordinate = this.findTopmostCorrdinate(latlngs);

      this.roof = roof[0];

      store.commit('setCoordinates', {
        coordinates: {
          lat: topCoordinate[0],
          lng: topCoordinate[1],
        },
      });

      if (window.matchMedia('(max-width: 47.99em)').matches) {
        const offset = this.map.getSize().y * 0.2;
        this.map.panBy(new L.Point(0, offset), { animate: false });
      } else {
        const offset = this.map.getSize().x * 0.2;
        this.map.panBy(new L.Point(offset, 0), { animate: false });
      }
    },
    selectRoof(lat, lng) {
      this.getRoof(lat, lng).then(roof => {
        // Prevent users from selecting roof we cannot place panels on
        const minRoofSize = 22;
        if (roof.length && roof[0].Areal2D < minRoofSize) {
          this.findBestRoof(
            {
              lat,
              lng,
            },
            'Taket du valgte er for lite. Finner best egnede takflate'
          );
        } else {
          this.drawRoof(roof);
        }
      });
    },
    getRoof: function(lat, lng) {
      return axios
        .get(
          `//www.webatlas.no/WAAPI-Takflater/takflater/punkt?Y=${lat}&X=${lng}&api_key=${
            config.apiKey
          }&format=json`
        )
        .then(res => {
          return res.data;
        });
    },
    getRoofsByByggID: function(bygg_id) {
      return axios
        .get(
          `//www.webatlas.no/WAAPI-Takflater/takflater/bygning/${bygg_id}?api_key=${
            config.apiKey
          }&format=json`
        )
        .then(res => {
          return res.data;
        });
    },
    geometriToLatLng: function(geometri) {
      const coordinates = JSON.parse(geometri).coordinates;
      const latLngs = coordinates[0].map(c => [c[1], c[0]]);
      latLngs.pop();
      return latLngs;
    },
    findTopmostCorrdinate: function(coordinates) {
      if (coordinates.length <= 1) {
        return coordinates;
      }

      return coordinates.reduce((mostNorthernPoint, current) =>
        mostNorthernPoint[0] > current[0] ? mostNorthernPoint : current
      );
    },
    handleKeyPress: function(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        var mapCenter = this.map.getCenter();
        this.selectRoof(mapCenter.lat, mapCenter.lng);
      }
    },
    findBestRoof(coordinates, loadingText = 'Finner best egnede takflate...') {
      store.commit('setLoadingText', loadingText);
      this.isLoading = true;

      this.getRoof(coordinates.lat, coordinates.lng).then(roof => {
        const data = {
          roof: roof,
          coordinates: coordinates,
        };
        http
          .post(`/solkart-roofselector`, data)
          .then(response => {
            this.drawRoof(response.data);
            store.commit('setIsAutoSelectedRoof', true);
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;
            return err;
          });
      });

      store.commit('setCoordinatesTriggerNavigation', false);
    },
    navigateToRoof(lat, lng) {
      this.map.setView([lat, lng], 20);
    },
  },
  mounted() {
    this.map = L.map('sunmap').setView([59.5139427335891, 5.33678257470646], 9);
    document.getElementById('sunmap').style.cursor = 'default';

    new L.tileLayer.webatlas({
      mapType: L.TileLayer.Webatlas.Type.HYBRID,
      apikey: config.apiKey,
    }).addTo(this.map);

    this.map.on('click', event => {
      store.commit('setIsAutoSelectedRoof', false);
      this.map.invalidateSize();
      this.selectRoof(event.latlng.lat, event.latlng.lng);
    });
  },
};
</script>

<style>
@media (min-width: 48em) {
  .map-container {
    height: calc(100vh - 16rem) !important;
  }
}

.map-container {
  width: 100%;
  display: flex;
  margin-top: -2em;
  margin-bottom: -2em;
  /* Subtract header and footer height from map container height */
  height: calc(100vh - 90px - 4rem);
}
.leaflet-container {
  border-radius: 0.1em 0.1em 0 0;
}
#sunmap {
  width: 100%;
  height: 100%;
  z-index: 0;
}
</style>
